export default "__VITE_ASSET__Doip_baR__"